import { LocationConfigDTO } from '../dto';

export interface LocationConfigProps {
  id: number;
  name: string;
}
export class LocationConfig {
  id: number;
  name: string;

  constructor({ id, name }: LocationConfigProps) {
    this.id = id;
    this.name = name;
  }

  static fromDto = (dto: LocationConfigDTO): LocationConfig =>
    new LocationConfig({
      id: dto.id,
      name: dto.name,
    });
}
